import React from 'react';

import { styled } from '@mui/material';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import GlossaryLoadingCard from '~/pages/DiscoverPage/components/GlossaryLoadingCard';
import HitLoadingCard from '~/pages/DiscoverPage/components/HitLoadingCard';
import { HITS_TYPES } from '~/pages/const';
import { LARGE_MARGIN_PX, SKELETON_TEXT_HEIGHT_BIG_PX, SMALL_MARGIN_PX } from '~/theme';

const LoadingHits = ({ isGridView, serpType, hasSearchTerm }) => {
  const onGlossaryPage = serpType === HITS_TYPES.GLOSSARY;
  const onInsightsPage = serpType === HITS_TYPES.NEWS;
  const isGlossaryWithoutSearch = onGlossaryPage && !hasSearchTerm;

  return (
    <>
      {isGlossaryWithoutSearch && (
        <>
          <LoadingLetterLine className="hit-letter" xs={SKELETON_TEXT_HEIGHT_BIG_PX} />
          {new Array(7).fill(null).map((item, i) =>
            isGridView ? (
              <li key={i}>
                <LoadingGridHit />
              </li>
            ) : (
              <GlossaryLoadingCard key={i} />
            ),
          )}
          <LoadingLetterLine xs={SKELETON_TEXT_HEIGHT_BIG_PX} />
          {new Array(9).fill(null).map((item, i) =>
            isGridView ? (
              <li key={i}>
                <LoadingGridHit />
              </li>
            ) : (
              <GlossaryLoadingCard key={i} />
            ),
          )}
          <LoadingLetterLine xs={SKELETON_TEXT_HEIGHT_BIG_PX} />
          {new Array(8).fill(null).map((item, i) =>
            isGridView ? (
              <li key={i}>
                <LoadingGridHit />
              </li>
            ) : (
              <GlossaryLoadingCard key={i} />
            ),
          )}
        </>
      )}
      {!isGlossaryWithoutSearch &&
        isGridView &&
        new Array(24).fill(null).map((item, i) => (
          <li key={i}>
            <LoadingGridHit />
          </li>
        ))}
      {!isGlossaryWithoutSearch &&
        !isGridView &&
        new Array(25)
          .fill(null)
          .map((item, i) =>
            onGlossaryPage ? (
              <GlossaryLoadingCard key={i} />
            ) : (
              <HitLoadingCard key={i} withCategories={!onInsightsPage} />
            ),
          )}
    </>
  );
};

export default LoadingHits;

const LoadingGridHit = styled(AnimatedSkeleton)`
  height: 338px;
  margin-bottom: ${SMALL_MARGIN_PX};
`;

const LoadingLetterLine = styled(AnimatedSkeleton)`
  margin: ${LARGE_MARGIN_PX} 0;
  &:first-child {
    margin-top: 0;
  }
`;
